import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InductionValidationResult } from 'src/app/models/induction-validation-result.model';
import { UserService } from '../user/user.service';

@Injectable({
  providedIn: 'root'
})
export class SiteInductionValidationService {

  constructor(private _userService: UserService) {}

  validate(brandId: string, brandName: string, inductionId: string): Observable<InductionValidationResult> {
    return this._userService.validateInduction(brandId, inductionId);
  }
}
